import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

export default ({
  input,
  label,
  type,
  meta: { touched, error, warning },
  style,
  className,
  ...custom
}) => (
  <div style={style} className={className}>
    {type !== 'textarea' && type !== 'checkbox' && <TextField
      label={label}
      error={!!(touched && error)}
      {...input}
      {...custom}
      style={{width: '100%'}}
      className="input-border"
    />}
    {type === 'textarea' && <TextField
      label={label}
      error={!!(touched && error)}
      multiline={true}
      rowsMax={5}
      {...input}
      {...custom}
      style={{width: '100%', paddingTop: 40}}
      className="input-border"
    />}
    {type === 'checkbox' && 
    <Checkbox
      color="primary"
      checked={input.value ? true : false}
      onChange={input.onChange}
    />
    }
    {touched && ((error && <p className="help is-danger" style={{color: '#f44336'}}>{error}</p>) || (warning && <span>{warning}</span>))}
  </div>
)
